import PropTypes from "prop-types";
import { useMetaTags } from "react-metatags-hook";
import PageHeader from "@/components/layout/page-header.jsx";
import { getAssetImageUrl } from "@/util/common.js";
import { defaultOpenGraphImage, isTestMode } from "@/util/const.js";
import { ProductContext } from "../../context/productContext.js";

CustomizePageLayout.propTypes = {
  images: PropTypes.array,
  children: PropTypes.node,
  type: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
  shortDescription: PropTypes.string,
  overview: PropTypes.node,
  name: PropTypes.string,
  buttonText: PropTypes.any,
  obsDimensions: PropTypes.oneOfType([
    PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        width: PropTypes.string,
        height: PropTypes.string,
      }),
    ),
  ]),
  parents: PropTypes.array,
  additionalHeroContent: PropTypes.node,
  disclaimer: PropTypes.any,
  constrainedCustomization: PropTypes.bool,
};

export default function CustomizePageLayout({
  images,
  name,
  description,
  shortDescription,
  type,
  obsDimensions,
  children,
  parents,
  constrainedCustomization = false,
  overview,
}) {
  const links = [...(parents || []), { title: name }];
  let metaImage;

  if (images && images.length > 0) {
    metaImage = getAssetImageUrl(images[0]);
  } else {
    metaImage = defaultOpenGraphImage;
  }

  useMetaTags(
    {
      title: `${name} | ${isTestMode ? "" : "St. Jude "}Play Live Tools`,
      description: description || shortDescription,
      openGraph: {
        image: metaImage,
        description: description || shortDescription,
      },
    },
    [name, description, shortDescription, metaImage],
  );

  return (
    <div className="max-w-screen-2xl relative flex flex-col items-center">
      <div
        className={`hero w-full pt-0 overflow-x-hidden ${constrainedCustomization ? "max-w-screen-md" : ""}`}
      >
        <div className="hero-content md:ml-6 pt-5 max-w-full w-full overflow-x-hidden flex-col items-start">
          <div>
            <PageHeader name={name} links={links} />
            <div className="mt-1 flex flex-col">
              <p className="text-sm">{overview}</p>
            </div>
          </div>

          <div className="overflow-x-hidden w-full mb-4">
            <ProductContext.Provider value={{ name, obsDimensions, type }}>
              {children}
            </ProductContext.Provider>
          </div>
        </div>
      </div>
    </div>
  );
}
